import { Packaging } from './Packaging';

export default Packaging;
